var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_91_9361)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 38,
    fill: "#E8EEFD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 36.5,
    stroke: "white",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_91_9361",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 22,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_91_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 59.8V62.5C34 62.925 33.8563 63.2812 33.5688 63.5688C33.2813 63.8563 32.925 64 32.5 64H31.5C31.075 64 30.7188 63.8563 30.4313 63.5688C30.1438 63.2812 30 62.925 30 62.5V46.3L34.25 33.5C34.4167 33.0333 34.6917 32.6667 35.075 32.4C35.4583 32.1333 35.9 32 36.4 32H59.6C60.1 32 60.5417 32.1333 60.925 32.4C61.3083 32.6667 61.5833 33.0333 61.75 33.5L66 46.3V62.5C66 62.925 65.8563 63.2812 65.5688 63.5688C65.2813 63.8563 64.925 64 64.5 64H63.45C63.025 64 62.6688 63.8563 62.3813 63.5688C62.0938 63.2812 61.95 62.925 61.95 62.5V59.8H34ZM34.15 43.3H61.85L59.1 35H36.9L34.15 43.3ZM38.2883 54.3C39.0628 54.3 39.7083 54.0375 40.225 53.5125C40.7417 52.9875 41 52.35 41 51.6C41 50.8222 40.7375 50.1611 40.2125 49.6167C39.6875 49.0722 39.05 48.8 38.3 48.8C37.5222 48.8 36.8611 49.0711 36.3166 49.6133C35.7722 50.1554 35.5 50.8137 35.5 51.5883C35.5 52.3628 35.7711 53.0083 36.3133 53.525C36.8554 54.0417 37.5137 54.3 38.2883 54.3ZM57.75 54.3C58.5278 54.3 59.1889 54.0375 59.7334 53.5125C60.2778 52.9875 60.55 52.35 60.55 51.6C60.55 50.8222 60.2789 50.1611 59.7367 49.6167C59.1946 49.0722 58.5363 48.8 57.7617 48.8C56.9872 48.8 56.3417 49.0711 55.825 49.6133C55.3083 50.1554 55.05 50.8137 55.05 51.5883C55.05 52.3628 55.3125 53.0083 55.8375 53.525C56.3625 54.0417 57 54.3 57.75 54.3Z",
    fill: "#1C53EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_91_9361",
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.73191 0 0 0 0 0.766782 0 0 0 0 0.820833 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_9361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_9361",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaser);
export default __webpack_public_path__ + "static/media/chaser.b59096d411ef8a84fceac08da9e8699e.svg";
export { ForwardRef as ReactComponent };